import React, { useContext } from "react";
import SwiperCore, { EffectCoverflow, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import template1 from "../../assets/img/template-1.jpg";
import template2 from "../../assets/img/template-2.jpg";
import template3 from "../../assets/img/template-3.jpg";

import "swiper/components/effect-coverflow/effect-coverflow.scss";
import "swiper/components/pagination/pagination.scss";

import "../../assets/styles/Arrow.scss";
import { StoreContext } from "../context/Store";

export interface SliderProps {}

export interface SliderState {}

SwiperCore.use([EffectCoverflow, Pagination, Navigation]);

export const Slider = (props: SliderProps) => {
  const store = useContext(StoreContext);
  return (
    <div className="slider">
      <div className="slider-wrapper">
        <div className="slider-content">
          <Swiper
            effect="coverflow"
            initialSlide={store.activeTemplate}
            centeredSlides
            slidesPerView="auto"
            pagination={{ clickable: true, el: ".swiper-pagination" }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            coverflowEffect={{
              slideShadows: false,
              rotate: 0,
            }}
            onSlideChange={(e) => store.setActiveTemplate(e.activeIndex)}
          >
            <SwiperSlide>
              <img src={template1} alt="template 1" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={template2} alt="template 2" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={template3} alt="template 3" />
            </SwiperSlide>
            <div className="arrow pink swiper-button-prev"></div>
            <div className="arrow pink swiper-button-next"></div>
          </Swiper>
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
